// import BaseFormPresenter from "../../../../base/BaseFormPresenter";

import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";

class ContributionFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  // showSuccess() {
  //   console.warn("SDFSDf");
  //   return this.showSuccess("WWWWWWWWWW");
  // }
  async save() {
    const collection = this.view.getCollectionName();
    if (this.object.id) {
      this.change.id = this.object.id;
    } else {
      this.change.acl = this.view.getAcl();
    }
    try {
      const compute = this.view.getStateComputation();
      const roundUp = this.view.state.roundUp;
      const roundDown = this.view.state.roundDown;

      if (compute === null) {
        throw new Error("Select Computation");
      }

      this.change.contribution_method = compute;
      this.change.roundUp = roundUp;
      this.change.roundDown = roundDown;
      this.change.status = "active";

      await this.upsertUseCase.execute(collection, this.change);
      this.change = {};
    } catch (error) {
      throw error; // rethrow the error to be caught by the caller
    }
  }
}

export default ContributionFormPresenter;
